import {Injectable} from '@angular/core';
import {
    HttpClient,
    HttpEvent,
    HttpErrorResponse,
    HttpEventType,
    HttpHeaders,
    HttpParams,
    HttpResponse
} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment} from '@env/environment';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';

@Injectable({
    providedIn: 'root'
})
export class UploadService {


    private apiURL = environment.apiURL;
    eventData = null;

    constructor(private httpClient: HttpClient, public taskService: TaskService) {
    }

    public setEvent(event)
    {
      this.eventData = event;
    }

    public removeEvent()
    {
      this.eventData.target.value = null;
    }

    public upload(formData) {

        return new Promise((resolve, reject) => {
            this.httpClient.post(this.apiURL + '/upload/file', formData, {
                reportProgress: true,
                observe: 'events'
            }).toPromise().then(result => {
                if (result instanceof HttpResponse) {
                    resolve(result.body);
                }
            }, (error) => {
                reject(error);
            });
        });


    }

    public unlinkAttachments() {
        let attach = JSON.stringify(this.taskService.attachments);
        const params = new HttpParams()
            .set('attachments', attach);
        return this.httpClient.post<any>(this.apiURL + '/upload/unlinkFiles', {params: params});
    }

    public downloadFile(item) {
        const params = new HttpParams()
            .set('id', '4');
        return this.httpClient.post<any>(this.apiURL + '/upload/downloadFile', {params: params});
    }

    public removeSingleFile(attachmentData, taskId) {
        const params = new HttpParams()
            .set('params', attachmentData)
            .set('taskId', taskId);
        return this.httpClient.post<any>(this.apiURL + '/upload/removeSingleAttachment', {params: params});
    }

    public deleteFileFromStorage(attachmentData) {
        const params = new HttpParams()
            .set('params', attachmentData);
        return this.httpClient.post<any>(this.apiURL +
            '/upload/deleteFileFromStorage', {params: params}
        );
    }

}
